import { Component } from '@angular/core';

@Component({
  selector: 'broker-warning-octagon-svg',
  templateUrl: './warning-octagon-svg.component.svg'
})
export class WarningOctagonSvgComponent {}
